import type { ReactEventHandler } from 'react';

export const stopPropagation: ReactEventHandler<HTMLElement> = event => {
  event.stopPropagation();
};

export const preventDefault: ReactEventHandler<HTMLElement> = event => {
  event.preventDefault();
};
